import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { EndAssignmentReason } from "@/modules/assignments/constants/endAssignmentReason"
import { UserModel } from "@/modules/users/models/userModel"

import { EndConsultantRequestStatus } from "../../end_consultant/constants/endConsultantRequestStatus"
import {
  EndConsultantOfferData,
  EndConsultantOfferModel,
} from "./endConsultantOfferModel"
import {
  ExtensionConfirmationEmailData,
  ExtensionConfirmationEmailModel,
} from "@/modules/extension/models/extensionConfirmationEmailModel"

export interface EndConsultantRequestData {
  uid: string
  consultantId: string
  contractId?: string
  status: EndConsultantRequestStatus
  endDate: string
  originalEndDate?: string
  reason: EndAssignmentReason
  additionalDetails?: string
  preContract?: boolean
  cancelMessage?: string
  created: string
  requester?: UserModel | null
  /** Absent on GET until the end-request payload includes the supplier contact. */
  primaryContact?: UserModel | null
  offers?: EndConsultantOfferData[]
  confirmationEmail?: ExtensionConfirmationEmailData | null
}

@Serializable
export class EndConsultantRequestModel {
  uid: string = ""
  consultantId: string = ""
  contractId: string = ""
  status: EndConsultantRequestStatus = EndConsultantRequestStatus.NotDefined
  endDate: string = ""
  originalEndDate: string = ""
  reason: EndAssignmentReason = EndAssignmentReason.NotDefined
  additionalDetails: string = ""
  preContract: boolean = false
  cancelMessage: string = ""
  created: string = ""
  requester: UserModel | null = null
  primaryContact: UserModel | null = null
  offers: EndConsultantOfferModel[] = []
  confirmationEmail: ExtensionConfirmationEmailModel | null = null
  constructor(data: EndConsultantRequestData | null = null) {
    if (data) {
      this.uid = data.uid ?? ""
      this.consultantId = data.consultantId ?? ""
      this.contractId = data.contractId ?? ""
      this.status = data.status ?? EndConsultantRequestStatus.NotDefined
      this.endDate = data.endDate ?? ""
      this.originalEndDate = data.originalEndDate ?? ""
      this.reason = data.reason ?? EndAssignmentReason.NotDefined
      this.additionalDetails = data.additionalDetails ?? ""
      this.preContract = data.preContract ?? false
      this.cancelMessage = data.cancelMessage ?? ""
      this.created = data.created ?? ""
      this.requester = data.requester ? new UserModel(data.requester) : null
      this.primaryContact = data.primaryContact
        ? new UserModel(data.primaryContact)
        : null
      this.offers =
        data.offers?.map((offer) => new EndConsultantOfferModel(offer)) ?? []
      this.confirmationEmail = data.confirmationEmail
        ? new ExtensionConfirmationEmailModel(data.confirmationEmail)
        : null
    }
  }
}
